module.exports = __webpack_public_path__ + "img/step-by-step.ade7c3a7.svg";